// Create the global variable 'Belimo'.
// This is needed, as multiple belimo scripts rely on this variable to be available.
window.Belimo = window.Belimo || {};
